var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-collapse',{attrs:{"type":"margin"}},[_c('app-collapse-item',{attrs:{"title":_vm.$t('service-subscription.subscription'),"is-visible":true}},[_c('subscription-settings')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }